import Loader from "components/Loader/loader"
import React, { useEffect, useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
} from "reactstrap"
import Swal from "sweetalert2"
import { fetchData, FetchPutData } from "utils/Common_api_functions"

const PartialModal = ({ isOpen, toggle, orderData, refreshOrders }) => {
  const [products, setProducts] = useState([])
  const [reason, setReason] = useState("")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (orderData?.productIdsAndQty) {
      setProducts(orderData.productIdsAndQty)
      setReason("")
    }
  }, [orderData])

  const updateQty = (index, value) => {
    const updated = [...products]
    updated[index].qty = Number(value)
    setProducts(updated)
  }

  const submitPartialApprove = async () => {
    if (!reason.trim()) {
      Swal.fire("Required", "Reason is required", "warning")
      return
    }

    const payload = {
      status: "Approve partially",
      productIdsAndQty: products,
      remark: reason,
    }

    const res = await FetchPutData(setLoading, "order", orderData?.id, payload)

    if (res?.data?.success) {
      Swal.fire("Success", "Order partially approved", "success")
      toggle()
      refreshOrders()
    } else {
      Swal.fire("Error", res?.response?.data?.message || "Failed", "error")
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      {loading && <Loader />}
      <ModalHeader toggle={toggle}>Approve Partially</ModalHeader>

      <ModalBody>
        <Table bordered striped className="bg-light">
          <thead className="bg-blue">
            <tr>
              <th>Product</th>
              <th>Approved Qty</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, i) => (
              <tr key={p.id}>
                <td>{p.productName}</td>
                <td>
                  <input
                    type="number"
                    className="form-control w-auto"
                    min={0}
                    value={p.qty}
                    onChange={e => updateQty(i, e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <label className="fw-bold mt-3">Reason</label>
        <textarea
          className="form-control"
          rows={3}
          value={reason}
          onChange={e => setReason(e.target.value)}
        />
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="success" onClick={submitPartialApprove}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PartialModal
